var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chapterButtons)?_c('chapter-button',{staticClass:"chapter-button",attrs:{"type":"previous","disabled":_vm.previousChapterDisabled,"color":_vm.color,"data-test":"chapter-previous"},on:{"click":_vm.dispatch}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }